module.exports = __webpack_public_path__ + "static/media/PoppinsSemiBold.6f1520d1.ttf";